import React from 'react'
import styled from 'styled-components'

export interface PlusMinusIconProps {
  className?: string
  minus?: boolean
}

const StyledPlusMinusIcon = styled.svg<{ $minus: boolean }>`
  display: inline-block;
  height: 1em;
  vertical-align: -0.125em;
  rect.upright {
    transition: all 0.5s;
    transform-origin: 50% 50%;
    transform: ${({ $minus }) => ($minus ? 'rotate(270deg)' : 'rotate(0)')};
  }
`

export const PlusMinusIcon: React.VFC<PlusMinusIconProps> = ({ className, minus = false }) => (
  <StyledPlusMinusIcon
    className={className}
    height="14"
    $minus={minus}
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect className="upright" fill="currentColor" height="12" width="1.5" x="6.25" y="1" />
    <rect fill="currentColor" height="1.5" width="12" x="1" y="6.25" />
  </StyledPlusMinusIcon>
)
